import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Types
import { IconProps } from '../../types/display/icon';

export const Icon = ({
  icon,
  spin,
  size,
  title,
  colour,
  addIcon,
  rotation,
  className,
  fixedWidth,
  featuredIcon,
  ...otherProps
}: IconProps) => (
  <Wrapper featuredIcon={featuredIcon}>
    <FontAwesomeIcon
      icon={icon}
      spin={spin}
      size={size}
      title={title}
      rotation={rotation}
      fixedWidth={fixedWidth}
      className={classNames({
        icon: addIcon,
        [`${colour}`]: colour,
        [`${className}`]: className,
      })}
      {...otherProps}
    />
  </Wrapper>
);

type WrapperProps = {
  children: ReactNode;
  featuredIcon?: boolean;
};

const Wrapper = ({ children, featuredIcon }: WrapperProps) => {
  const shouldRenderWrapper = featuredIcon;

  return (
    <>
      {!shouldRenderWrapper && children}
      {shouldRenderWrapper && <div className="featured-icon">{children}</div>}
    </>
  );
};
